import { Component } from '@angular/core';

// How to run the installer zip on each system; used on /instalar and at the end of /cadastro.
@Component({
    selector: 'app-install-steps',
    template: `
      <div class="steps">
        <h2>Windows 10 ou 11</h2>
        <ol>
          <li>Descompacte o arquivo baixado.</li>
          <li>Na pasta <code>ncscripts-master</code>, dê dois cliques em <code>InstaladorWindows.bat</code>.</li>
          <li>Aceite o pedido de administrador e siga as instruções na tela.</li>
        </ol>
        <h2>Ubuntu</h2>
        <ol>
          <li>Descompacte o arquivo baixado.</li>
          <li>Abra um terminal na pasta <code>ncscripts-master</code> e rode <code>./instalador_linux.sh</code>
            (sem <code>sudo</code>).</li>
        </ol>
        <p class="hint">No fim, o navegador abre o NCommerce sozinho. Entre com o usuário <strong>admin</strong> e a senha
          <strong>admin123</strong> e troque a senha logo em seguida.</p>
      </div>`,
    styles: [`.steps { text-align: left; } h2 { font-size: 1.2em; margin-top: 1.5em; } .hint { color: #666; }`],
    standalone: false
})
export class InstallStepsComponent { }
